import types from './types';

const defaultState = {
  chemProdTitleChange: 0
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.UPDATE_CHEM_PROD_TITLE:
      return { ...state, chemProdTitleChange: state.chemProdTitleChange + 1 };

    default:
      return state;
  }
};
